<div class="text-left select-none" *transloco="let t">
    <p class="p-2">
        <p-checkbox #confirmCheckbox [(ngModel)]="checkboxValue" [binary]="true"></p-checkbox>
        <span class="relative ml-2 cursor-pointer top-2px" (click)="checkboxValue = !checkboxValue">{{ confirmCheckboxText ?? t('confirm_awareness') }}</span>
    </p>
    <hr class="separator">
    <p>
        <button type="button" pButton [disabled]="!checkboxValue" icon="icon-checkmark-fill" [label]="t('yes')" (click)="confirmDialog.onAccept()"></button>
        <button type="button" pButton class="float-right p-button-link" [label]="t('cancel')" (click)="confirmDialog.onReject()"></button>
    </p>
</div>